<template>
  <div class="merge-modal-wrapper">
    <NavbarDesktop
      @onConfirmAction="emitMerge"
      @onDiscardAction="emitCancel"
      :action="{ type: 'merge' }"
      :cheksSelected="canMerge"
    />
    <!-- <h4 class="merge-modal-header">{{ $t('merge.title') }}</h4> -->
    <div class="merge-modal-body">
      <div v-for="order in orders" :key="order._id" @click="select(order._id)">
        <QueueItem :class="makeItemClass(order._id)" :order="order" readonly />
      </div>

      <div v-if="!isDesktop" class="fixed-wrapper">
      
          <QueueButton variant="cancel" class="action-cancel-button" @click="emitCancel">
            <img src="/icons/back2.svg" class="del" />
          </QueueButton>
          <QueueButton variant="confirm" class="w-100" :disabled="!canMerge" @click="emitMerge">
            {{ $t('merge.confirm') }}
            <span v-if="canMerge">({{selected.length}}x)</span>
          </QueueButton>
        
      </div>
    </div>
  </div>
</template>

<script>
import QueueItem from "@/components/QueueItem.vue";
import QueueButton from "@/components/QueueButton.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";

export default {
  props: {
    orders: Array,
  },
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    select(id) {
      if (this.selected.includes(id)) {
        const index = this.selected.indexOf(id);

        if (index != 0) this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }
    },
    makeItemClass(id) {
      return {
        "merge-modal-item": true,
        "selected-item": this.selected.includes(id),
        "first-item": this.selected.indexOf(id) === 0,
      };
    },
    emitCancel() {
      this.$emit("cancel");
    },
    emitMerge() {
      this.$emit("merge", this.selected[0], this.selected.slice(1));
    },
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    canMerge() {
      return this.selected.length > 1;
    },
  },
  mounted() {
    this.selected = [this.orders[0]._id];
  },
  components: {
    QueueItem,
    QueueButton,
    NavbarDesktop,
  },
};
</script>

<style scoped>
.fixed-wrapper {
  background: #1d1d1d;
    bottom: 0;
    display: flex;
 
    justify-content: space-between;
    padding: 1.3vh 3.2vh 2.6vh;
    z-index: 5;
    width: 100%;
    position: fixed;
    left: 0;
}
.mt-10 {
  margin-top: 1.7vh !important;
}

.actions-cheque {
  display: flex;
  justify-content: space-between;
  margin-top: 2.1vh;
  padding: 0 5.4vw;
  width: 100%;
}

.merge-modal-wrapper {
  height: 100%;
  background: #ededed;
  z-index: 2;
  top: 0;
  position: absolute;
  width: 100%;
}

.w-80 {
  width: 80%;
}

.merge-modal-body {
  position: relative;
  top: 7.8vh;
  left: 0;
  
  margin-bottom: 5vh;
  width: 100%;
  padding: 0 2.5vh 15vh;
  z-index: 2;
}

.merge-modal-header {
  position: absolute;
  left: 2.5vh;
  top: 8vh;
  width: 100%;
  margin: 0;
  z-index: 2;
  color: black;
}

.selected-item {
  border: 2px solid #129b81 !important;
  border-radius: 3vh;
}

.first-item {
  border-color: #129b81;
}

.merge-modal-item {
  width: 100%;
  border-radius: 2.7vh;
}

.merge-modal-actions {
  background: #1d1d1d;
  bottom: 0;
  padding: 1.3vh 2.5vh 3.5vh;
  z-index: 5;
  width: 100%;
  justify-content: space-between;
  position: fixed;
  display: flex;
  left: 0;
}
@media screen and (min-width: 768px) {
  .merge-modal-wrapper {
    height: 100vh;
  }
  .merge-modal-wrapper::-webkit-scrollbar {
    width: 0;
  }
  .merge-modal-body {
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding: 9.722vw 13.715vw 0;
    margin: 0;
    width: 100vw;
  }
  .merge-modal-body div {
    margin-right: 1.389vw;
  }
  .merge-modal-body div:nth-child(3n) {
    margin-right: 0;
  }
}
</style>
